module.exports = __webpack_public_path__ + "static/media/aeronave.5d1a3a56.glb";